import React, { useEffect, useRef } from 'react'
import { each, sumBy  } from 'lodash'
// import { useNavigate } from "react-router-dom"

import { getCoords, mapStyling } from '../../helpers/maps'

export default ({ clinics, activeClinic, zoom }) => {
  // const navigate = useNavigate()
  const ref = useRef();

  useEffect(() => {
    const centerLat = sumBy(clinics, (clinic) => { return parseFloat(clinic.latitudeLongitude.split(',')[0]) })/clinics.length
    const centerLng = sumBy(clinics, (clinic) => { return parseFloat(clinic.latitudeLongitude.split(',')[1]) })/clinics.length

    let _center = {
      lat: centerLat,
      lng: centerLng,
    }

    if (activeClinic) {
      _center = getCoords(activeClinic.latitudeLongitude)
    }

    const googleMap = new window.google.maps.Map(ref.current, {
      center: _center,
      zoom: zoom,
      styles: mapStyling,
      disableDefaultUI: true,
      zoomControl: true,
      scaleControl: true,
    });

    each(clinics, (clinic) => {
      const _position =  getCoords(clinic.latitudeLongitude)
    
      if (_position) {
        const isActiveClinic = activeClinic ? activeClinic.name === clinic.name : false

        let iconUrl = '/assets/google_map_marker.svg'

        if (activeClinic) {
          iconUrl = isActiveClinic ? '/assets/google_map_marker_active.svg' : '/assets/google_map_marker_small.svg'
        }

        const _icon = {
          url: iconUrl, // url
          scaledSize: new window.google.maps.Size(40, 50), // scaled size
          origin: new window.google.maps.Point(0,0), // origin
        };

        const _marker = new window.google.maps.Marker({
          position: _position,
          title: clinic.name,
          icon: _icon
        })

        _marker.setMap(googleMap)

        _marker.addListener("click", () => {
          window.open(clinic.googleMapsUrl, '_blank');
          // return

          // if (isActiveClinic) {
          //   window.open(clinic.googleMapsUrl, '_blank');
          // } else {
          //   navigate(`/${clinic.url}`)
          // }
        });
      }
    })
  });

  return <div ref={ref} id="map" className="w-full h-[500px]" />;
}